import type { PropsWithChildren } from 'react';

import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { PATH_DASHBOARD } from '../../routes/paths';

type Tab = {
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    label: 'profile',
    value: 'profile',
  },
  {
    label: 'placements',
    value: 'placements',
  },
];

type CustomerDetailsNavigatorContextType = {
  currentTab: string;
  id: string;
  tabs: Tab[];
};

const defaultCustomerDetailsNavigatorContextValue = {
  currentTab: 'profile',
  id: '',
  tabs: defaultTabs,
};

export const CustomerDetailsNavigatorContext =
  createContext<CustomerDetailsNavigatorContextType>(
    defaultCustomerDetailsNavigatorContextValue
  );

type CustomerDetailsNavigatorContextProviderProps = PropsWithChildren<any>;

export const CustomerDetailsNavigatorContextProvider = ({
  children,
}: CustomerDetailsNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<CustomerDetailsNavigatorContextType>(
      defaultCustomerDetailsNavigatorContextValue
    );

  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (id) {
      setContextValue((prev) => ({ ...prev, id }));

      if (pathname) {
        let currentTab = pathname.replace(
          `${PATH_DASHBOARD.customer.details(id)}/`,
          ''
        );
        currentTab = currentTab || defaultTabs[0].value;

        setContextValue((prev) => ({ ...prev, currentTab }));
      }
    } else {
      navigate(PATH_DASHBOARD.customer.list);
    }
  }, [id, navigate, pathname]);

  return (
    <CustomerDetailsNavigatorContext.Provider value={{ ...contextValue }}>
      {children}
    </CustomerDetailsNavigatorContext.Provider>
  );
};

export const useCustomerDetailsNavigatorContext = () => {
  return useContext(CustomerDetailsNavigatorContext);
};
